import { render, staticRenderFns } from "./AirPassportKazgidromet.vue?vue&type=template&id=3fd24a81&scoped=true&"
import script from "./AirPassportKazgidromet.vue?vue&type=script&lang=js&"
export * from "./AirPassportKazgidromet.vue?vue&type=script&lang=js&"
import style0 from "./AirPassportKazgidromet.vue?vue&type=style&index=0&id=3fd24a81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd24a81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
